const compact = params =>
    Object.fromEntries(
        Object.entries(params || {}).filter(
            ([, value]) => value !== '' && value !== null && value !== undefined
        )
    );

export const pushGtmEvent = (event, params = {}) => {
    if (!event) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...compact(params) });
};

const apartmentContext = () => {
    const root = document.querySelector('[data-gtm-apartment]');

    return root
        ? {
              id_mieszkania: root.dataset.gtmApartment,
              nazwa_osiedla: root.dataset.gtmEstateName,
              id_osiedla: root.dataset.gtmEstateId,
          }
        : {};
};

/*
 * TODO: Enable when Cookiebot is implemented and connect it to
 * CookiebotOnConsentReady, CookiebotOnAccept and CookiebotOnDecline.
 *
const updateGoogleConsent = consent => {
    const isGranted = (value, categories = []) => {
        if (value === true || value === 1) return true;
        if (Array.isArray(value)) {
            return value.some(item =>
                categories.includes(String(item).toLowerCase())
            );
        }

        return ['granted', 'accepted', 'allowed', 'allow', '1'].includes(
            String(value || '').toLowerCase()
        );
    };
    const analyticsGranted = isGranted(
        consent?.analytics ??
            consent?.statistics ??
            consent?.statistical ??
            consent?.categories,
        ['analytics', 'statistics', 'statistical']
    );
    const marketingGranted = isGranted(
        consent?.marketing ?? consent?.categories,
        ['marketing']
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'consent_update',
        consent_analytics: analyticsGranted ? 'granted' : 'denied',
        consent_marketing: marketingGranted ? 'granted' : 'denied',
    });

    if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
            analytics_storage: analyticsGranted ? 'granted' : 'denied',
            ad_storage: marketingGranted ? 'granted' : 'denied',
            ad_user_data: marketingGranted ? 'granted' : 'denied',
            ad_personalization: marketingGranted ? 'granted' : 'denied',
        });
    }
};
*/

const onTrackedClick = event => {
    const target = event.target.closest(
        '[data-gtm-estate-link], [data-gtm-find-apartment], [data-gtm-social], [data-gtm-apartment-cta], [data-gtm-floating-phone]'
    );
    if (!target) return;

    if (target.dataset.gtmEstateLink !== undefined) {
        pushGtmEvent('zobacz_osiedle', {
            nazwa_osiedla: target.dataset.gtmEstateName,
            id_osiedla: target.dataset.gtmEstateId,
            placement: target.dataset.gtmPlacement,
        });
        return;
    }

    if (target.dataset.gtmFindApartment !== undefined) {
        pushGtmEvent(
            target.dataset.gtmFindApartment || 'Znajdz_mieszkanie_button',
            { placement: target.dataset.gtmPlacement }
        );
        return;
    }

    if (target.dataset.gtmSocial) {
        const names = {
            facebook: 'Fb_klik_icon',
            email: 'Email_klik_icon',
            whatsapp: 'Whatsapp_klik_ikon',
        };
        pushGtmEvent(names[target.dataset.gtmSocial], {
            kanal: target.dataset.gtmSocial,
            placement: target.dataset.gtmPlacement,
            ...apartmentContext(),
        });
        return;
    }

    if (target.dataset.gtmApartmentCta !== undefined) {
        pushGtmEvent('Zapytanie_oferta', apartmentContext());
        return;
    }

    if (target.dataset.gtmFloatingPhone !== undefined) {
        pushGtmEvent('Tel_klik_icon', {
            numer_telefonu: target.dataset.gtmPhone,
            placement: 'floating_button',
            ...apartmentContext(),
        });
    }
};

const onApartmentContactClick = event => {
    if (!document.querySelector('[data-gtm-apartment]')) return;

    const link = event.target.closest('a[href^="tel:"], a[href^="mailto:"]');
    if (!link || link.closest('[data-gtm-social], [data-gtm-floating-phone]')) {
        return;
    }

    const href = link.getAttribute('href') || '';
    const isPhone = href.startsWith('tel:');
    pushGtmEvent(isPhone ? 'Klik_tel' : 'Klik_email', {
        ...apartmentContext(),
        [isPhone ? 'numer_telefonu' : 'adres_email']: href
            .replace(/^(tel:|mailto:)/, '')
            .trim(),
    });
};

const onFormSuccess = event => {
    const form = event.detail?.form;
    if (!form) return;

    const eventName = form.dataset.gtmFormEvent;
    if (!eventName) return;

    pushGtmEvent(eventName, {
        ...apartmentContext(),
        form_id: form.querySelector('[name="form_id"]')?.value,
    });
};

export const initAnalytics = () => {
    window.mdaPushGtmEvent = pushGtmEvent;
    // window.mdaUpdateGoogleConsent = updateGoogleConsent;

    document.addEventListener('click', onTrackedClick);
    document.addEventListener('click', onApartmentContactClick);
    document.addEventListener('mda:contact-form-success', onFormSuccess);

    // TODO: Replace with Cookiebot event listeners when Cookiebot is implemented.
    // ['mda:cookie-consent', 'mda-cookies:consent'].forEach(name => {
    //     document.addEventListener(name, event =>
    //         updateGoogleConsent(event.detail || {})
    //     );
    // });

    const context = apartmentContext();
    if (context.id_mieszkania) {
        pushGtmEvent('Szczegoly_mieszkania', context);
    }
};
